import { Button } from "@workspace/ui/components/button";
import Link from "next/link";

export function FooterCTA() {
  return (
    <div className="mx-4 mt-16 mb-16 flex flex-col items-center border border-border bg-muted px-6 py-10 text-center md:container sm:mt-20 sm:mb-24 sm:px-10 sm:py-14 md:mx-auto md:px-12 md:py-16 lg:mt-24 lg:mb-32 lg:px-24 lg:py-20">
      <span className="font-medium text-3xl text-primary leading-tight sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl dark:text-white">
        Job hunting made simple.
      </span>
      <p className="mt-4 max-w-3xl text-muted-foreground text-sm sm:mt-6 sm:text-base">
        Easy job discovery, seamless applications, local opportunities & smart
        matching.{" "}
        <span className="hidden sm:inline">
          <br />
          Connect with your next career opportunity today.
        </span>
      </p>

      <div className="mt-6 w-full sm:mt-8 sm:w-auto md:mt-10 md:mb-4 lg:mb-8">
        <div className="flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row sm:space-x-4">
          <Button asChild variant="default">
            <Link className="w-full sm:w-auto" href="/job-listings">
              Find a job
            </Link>
          </Button>

          <Button asChild variant="outline">
            <Link
              className="w-full sm:w-auto"
              href="/jobs?modal=create-job"
              rel="noopener noreferrer"
              target="_blank"
            >
              Post a job
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
